/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  QueryTrendSourceResult,
  QueryTrendSourceResult$inboundSchema,
} from "./querytrendsourceresult.js";

/**
 * Result of a single-chart trend query.
 */
export type QueryTrendsResult = {
  /**
   * The interval of the chart in seconds.
   */
  interval: number;
  /**
   * Map of source ID to result for that source.
   */
  sources: { [k: string]: QueryTrendSourceResult };
};

/** @internal */
export const QueryTrendsResult$inboundSchema: z.ZodType<
  QueryTrendsResult,
  z.ZodTypeDef,
  unknown
> = z.object({
  interval: types.number(),
  sources: z.record(QueryTrendSourceResult$inboundSchema),
});

export function queryTrendsResultFromJSON(
  jsonString: string,
): SafeParseResult<QueryTrendsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => QueryTrendsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'QueryTrendsResult' from JSON`,
  );
}
